import React from 'react';
import { DateInput } from './InputTypes/DateInput';
import { TextInputComponent } from './InputTypes/TextInput';
import { NumberInputComponent } from './InputTypes/NumberInput';
import { CurrencyInputComponent } from './InputTypes/CurrencyInput';
import { CheckboxInputComponent } from './InputTypes/CheckboxInput';
import { TextAreaInputComponent } from './InputTypes/TextAreaInput';

interface InputFactoryProps {
  fieldInputType: number;
  [key: string]: any;
}

export const InputFactory: React.FC<InputFactoryProps> = ({ fieldInputType, ...props }) => {
  const inputComponents: { [key: number]: React.ComponentType<any> } = {
    0: TextInputComponent,
    1: DateInput,
    2: NumberInputComponent,
    3: CurrencyInputComponent,
    4: CheckboxInputComponent,
    5: TextAreaInputComponent,
  };

  const InputComponent = inputComponents[fieldInputType];

  if (!InputComponent) {
    return <p>input not valid</p>;
  }
  const allProps = { fieldInputType, ...props };
  return <InputComponent {...allProps} />;
};
